<template>
	<div>
		<!-- Info Card -->
		<div class="card mb-3">
			<div class="card-body">
				<h6 class="card-title mb-3">Informasi Import</h6>
				<div class="info-item mb-2">
					<small class="text-muted">Supplier:</small>
					<div class="font-weight-medium">
						<!-- {{ selectedSupplier ? selectedSupplier.code : '-' }} -->
						{{ selectedSupplier ? selectedSupplier.name : '-' }}
						<small> - {{ selectedSupplier ? selectedSupplier.code : '-' }}</small>
					</div>
				</div>
				<div class="info-item mb-2">
					<small class="text-muted">Produk Termapping:</small>
					<div class="font-weight-medium">
						{{ mappedProductCount }} produk
					</div>
				</div>
				<div class="info-item mb-2">
					<small class="text-muted">Jumlah Paket:</small>
					<div class="font-weight-medium">
						{{ totalPackageCount }} paket
					</div>
				</div>
				<div class="info-item">
					<small class="text-muted">Harga Barang:</small>
					<div class="font-weight-medium text-success">
						{{ totalAmount ? formatMoney(totalAmount) : '-' }}
					</div>
				</div>

				<div class="info-item">
					<small class="text-muted">Total Handling Fee:</small>
					<div class="font-weight-medium" :class="{ 'text-primary': totalHandlingFee > 0 }">
						{{ totalHandlingFee ? formatMoney(totalHandlingFee) : '-' }}
					</div>
				</div>

				<div class="info-item">
					<small class="text-muted">Biaya Layanan:</small>
					<div class="font-weight-medium" :class="{ 'text-primary': platformFee > 0 }">
						{{ platformFee ? formatMoney(platformFee) : '-' }}
					</div>
				</div>
				<div class="info-item">
					<small class="text-muted">Grand Total:</small>
					<div class="grand-total-value">{{ grandTotal ? formatMoney(grandTotal) : '-' }}</div>
				</div>
			</div>
		</div>

		<!-- Action Buttons Card -->
		<div class="card">
			<div class="card-body">
				<h6 class="card-title mb-3">Aksi</h6>
				<div class="shop-actions">
					<!-- Back Button -->
					<button
						v-if="showBackButton"
						type="button"
						class="btn btn-outline-secondary w-100 mb-2"
						:disabled="isSubmitting || isProcessing"
						@click="handleBack"
					>
						<i class="material-icons">arrow_back</i>
						Kembali
					</button>

					<!-- Cancel Button -->
					<button
						type="button"
						class="btn btn-outline-danger w-100 mb-2"
						:disabled="isSubmitting"
						@click="handleCancel"
					>
						<i class="material-icons">cancel</i>
						Batal
					</button>

					<!-- Continue/Submit Button -->
					<button
						type="button"
						class="btn btn-primary w-100"
						:disabled="isSubmitting || isProcessing || !canContinue"
						:class="{ 'is-loading': isSubmitting }"
						@click="handleContinue"
					>
						<span
							v-if="isSubmitting"
							class="spinner-border spinner-border-sm mr-1"
							role="status"
							aria-hidden="true"
						></span>
						{{ isSubmitting ? 'Memproses...' : continueButtonText }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatMoney } from '@/lib/helper';

export default {
	name: 'SidebarInfo',
	props: {
		showBackButton: {
			type: Boolean,
			default: false,
		},
		canContinue: {
			type: Boolean,
			default: false,
		},
		continueButtonText: {
			type: String,
			default: 'Lanjut',
		},
		showGrandTotal: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters('importWholesaleOrder', [
			'selectedFile',
			'shippingLabelFile',
			'selectedSupplier',
			'mappingDataPerProduct',
			'mappingDataPerPackage',
			'totalAmount',
			'serviceFee',
			'isProcessing',
			'isSubmitting',
		]),
		mappedProductCount() {
			return this.mappingDataPerProduct.filter(item => item.isValid).length;
		},
		totalPackageCount() {
			return this.mappingDataPerPackage.length;
		},
		totalProductCount() {
			return this.mappingDataPerPackage.reduce((sum, pkg) => sum + pkg.items.filter(item => item.isValid).length, 0);
		},
		totalHandlingFee() {
			// Gunakan getter dari Vuex store
			return this.$store.getters['importWholesaleOrder/totalHandlingFee'];
		},
		platformFee() {
			// Biaya Layanan dari serviceFee config
			if (!this.serviceFee) {
				return 0;
			}
			return this.serviceFee.final_value || 0;
		},
		grandTotal() {
			return this.totalAmount + this.totalHandlingFee + this.platformFee;
		},
	},
	methods: {
		formatMoney,
		handleBack() {
			this.$emit('back');
		},
		handleCancel() {
			this.$emit('cancel');
		},
		handleContinue() {
			this.$emit('continue');
		},
	},
};
</script>

<style scoped>
.info-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 0.75rem;
}

.shop-actions {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.shop-actions .btn {
	padding: 0.75rem 1rem;
	font-size: 0.9rem;
	font-weight: 600;
}

/* Small spinner for buttons */
.spinner-border-sm {
	width: 1rem;
	height: 1rem;
	border-width: 0.2em;
}

.btn.is-loading {
	position: relative;
}

/* Grand Total Value */
.grand-total-value {
	font-weight: 700;
	font-size: 1.2rem;
	color: #276dc7;
}
</style>
